<template>
  <v-container>
    <v-layout>
      <v-flex md8>
        <form autocomplete="off">
          <v-text-field
            v-model="oldPassword"
            name="oldPassword"
            :error-messages="errors.collect('oldPassword')"
            autocomplete="oldPassword"
            data-vv-name="oldPassword"
            id="oldPassword"
            type="password"
            v-validate="'required'"
            label="Старый пароль"
            required
          ></v-text-field>
          <v-text-field
            v-model="newPassword"
            name="newPassword"
            ref="newPassword"
            autocomplete="newPassword"
            :error-messages="errors.collect('newPassword')"
            id="newPassword"
            type="password"
            data-vv-name="newPassword"
            v-validate="'required|min:6'"
            label="Новый пароль"
            required
          ></v-text-field>
          <v-text-field
            v-model="newPasswordConfirm"
            name="newPasswordConfirm"
            autocomplete="newPasswordConfirm"
            data-vv-name="newPasswordConfirm"
            id="newPasswordConfirm"
            :error-messages="errors.collect('newPasswordConfirm')"
            type="password"
            v-validate="'required|confirmed:newPassword'"
            label="Новый пароль (еще раз)"
            required
          ></v-text-field>
          <div class="text-sm-left text-xs-center">
            <v-btn
              depressed
              color="primary"
              @click="save"
              :disabled="isLoading"
              :loading="isLoading">
              Изменить пароль
            </v-btn>
          </div>
        </form>
      </v-flex>
    </v-layout>
    <v-snackbar
      color="success"
      :timeout="5000"
      :bottom="true"
      v-model="success"
    >
      Пароль изменен.
      <v-btn flat icon @click.native="success = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VeeValidateMessagesRU from 'vee-validate/dist/locale/ru'

Vue.use(VeeValidate, {
  locale: 'ru',
  dictionary: {
    ru: VeeValidateMessagesRU
  }
})
export default {
  name: 'ChangePassword',
  data () {
    return {
      isLoading: false,
      success: false,
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      dictionary: {
        attributes: {
          oldPassword: 'Старый пароль',
          newPassword: 'Новый пароль',
          newPasswordConfirm: 'Новый пароль (еще раз)'
          // custom attributes
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', {
      _errors: 'error'
    })
  },
  methods: {
    ...mapActions('user', {
      _changePassword: 'changePassword',
      _setError: 'setError'
    }),
    ...mapActions('auth', {
      _logout: 'logout'
    }),
    async save () {
      this._setError(false)
      this.errors.clear()
      this.isLoading = true
      await this.$validator.validateAll()
      if (!this.errors.any()) {
        try {
          let payload = {
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
            newPasswordConfirm: this.newPasswordConfirm
          }
          await this._changePassword(payload)
          let errors = this._errors
          for (let prop in errors) {
            this.errors.add({ field: prop, 'msg': errors[prop] })
            this.$validator.fields.find({ name: prop }).setFlags({
              valid: false,
              invalid: true,
              dirty: true
            })
          }
          if (!this._errors) {
            this.success = true
            this.$validator.reset()
            this.oldPassword = ''
            this.newPassword = ''
            this.newPasswordConfirm = ''
            this._logout()
            this.$router.push({ name: 'login' })
          }
        } catch (error) {
          let errors = this._errors
          for (let prop in this._errors) {
            this.errors.add({ field: prop, 'msg': errors[prop] })
            this.$validator.fields.find({ name: prop }).setFlags({
              valid: false,
              invalid: true,
              dirty: true
            })
          }
        } finally {
          this.isLoading = false
        }
      } else {
        this.isLoading = false
      }
    }
  },
  async mounted () {
    this.$validator.localize('ru', this.dictionary)
  }
}
</script>

<style scoped>

</style>
